<template>
    <div>
        <div class="mb-3">
            <label class="mb-1" for="owner">{{ $t('globals.owner') }}</label>
            <div class="flex flex-row">
                <div class="flex-1 lg:mr-3 mr-0">
                    <div class="card input-border-color mb-0">
                        <div class="card-body lg:px-4 px-3">
                            <div class="flex flex-row items-center">
                                <div class="lg:mr-4 mr-3">
                                    <avatar :user="organization.owner" :size="12"></avatar>
                                </div>
                                <div class="flex-1 lg:mr-4 mr-3">
                                    <h4 class="text-base mb-1 mt-0">{{ `${organization.owner.first_name} ${organization.owner.last_name}` }}</h4>
                                    <div>{{ organization.owner.email }}</div>
                                </div>
                                <svg v-if="userOwnsOrganization" v-tooltip="{ content: $t('organization_details.owner_tooltip_info'), placement: 'top' }" class="cursor-pointer fill-current h-6 hover:text-gray-800 lg:mr-2 mr-1 text-gray-700 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm2-13c0 .28-.21.8-.42 1L10 9.58c-.57.58-1 1.6-1 2.42v1h2v-1c0-.29.21-.8.42-1L13 9.42c.57-.58 1-1.6 1-2.42a4 4 0 1 0-8 0h2a2 2 0 1 1 4 0zm-3 8v2h2v-2H9z"/></svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-1 hidden lg:block"></div>
            </div>
            <p class="help-block">{{ $t('organization_details.owner_info') }}</p>
        </div>
        <div>
            <label class="mb-1" for="admins">{{ $t('organization_details.admins') }}</label>
            <div v-for="chunk in chunkedAdmins" class="flex flex-col md:flex-row">
                <template v-for="(admin, index) in chunk">
                    <div class="flex-1 mb-3" :class="{ 'md:mr-3 mr-0' : index === 0 }">
                        <div class="card input-border-color mb-0">
                            <div class="card-body lg:px-4 px-3">
                                <div class="flex flex-row items-center">
                                    <div class="lg:mr-4 mr-3">
                                        <avatar :user="admin" :size="12"></avatar>
                                    </div>
                                    <div class="flex-1 lg:mr-4 mr-3">
                                        <h4 class="text-base mb-1 mt-0">{{ `${admin.first_name} ${admin.last_name}` }}</h4>
                                        <div>{{ admin.email }}</div>
                                    </div>
                                    <svg v-if="userOwnsOrganization" @click="removeAdmin(admin.id)" v-tooltip="{ content: $t('organization_details.remove_admin'), placement: 'top' }" class="cursor-pointer fill-current h-6 hover:text-danger-600 lg:mr-2 mr-1 text-danger-500 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zM11.4 10l2.83-2.83-1.41-1.41L10 8.59 7.17 5.76 5.76 7.17 8.59 10l-2.83 2.83 1.41 1.41L10 11.41l2.83 2.83 1.41-1.41L11.41 10z"/></svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="chunk.length === 1" class="flex-1 mb-3">
                        <template v-if="userOwnsOrganization">
                            <add-admin-button></add-admin-button>
                        </template>
                        <template v-else></template>
                    </div>
                </template>
            </div>
            <div v-if="userOwnsOrganization && organization.admins.length % 2 === 0" class="flex flex-col md:flex-row">
                <div class="flex-1 mb-3 md:mr-3 mr-0">
                    <add-admin-button></add-admin-button>
                </div>
                <div class="flex-1 mb-3"></div>
            </div>
        </div>
    </div>
</template>

<script>
import AddAdminButton from './add-admin-button.vue';

export default {
    components: {
        'add-admin-button': AddAdminButton,
    },

    props: {
        organization: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: new Form({
                user_id: '',
            }),
        };
    },

    computed: {
        chunkedAdmins() {
            return _.chunk(this.organization.admins, 2);
        },

        userOwnsOrganization() {
            return window.Globals.user.id === window.Globals.user.organization.owner_id;
        },
    },

    methods: {
        removeAdmin(adminId) {
            this.form.user_id = adminId;

            Globals.put('/api/v1/toggle-user-is-admin-flag', this.form)
                .then(() => window.location.reload())
                .catch(() => {
                    window.toastr.clear();
                    window.toastr.error(this.$t('globals.unexpected_error'));
                });
        },
    },
};
</script>
